var DingTalk = function () {
  window.addEventListener('message', function (e) {
    var msg = e.data;

    if (msg.mtype === 'close') {
      window.MyCallbackTemp(msg.data);
    }
  }, false);
  var portal = {
    "ajaxRequest": window.XMLHttpRequest,
    "openWindow": function openWindow(url, callBack, options) {
      var div = document.createElement("div");
      div.innerHTML = '<a href="' + url + '">temp</a>';
      var alink = div.firstChild;
      url = alink.href;
      var store = {
        height: document.body.style.height,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };

      window.MyCallbackTemp = function (mdata) {
        document.getElementById("__myPop__").remove();
        document.body.style.height = store.height;
        document.body.style.width = store.width;
        document.body.style.overflow = store.overflow;
        callBack(mdata);
      };

      var win = document.getElementById("__myPop__") || document.createElement("div");
      win.id = "__myPop__";
      win.style.zIndex = "9999";
      win.style.width = "100%";
      win.style.height = "100%";
      win.style.position = 'fixed';
      win.style.top = '0';
      win.style.left = '0';
      win.innerHTML = '<iframe src="' + url + '" style="width:100%;height:100%;margin:0;background-color:white;" frameborder="0"></iframe>';
      document.getElementById("__myPop__") || document.body.appendChild(win);
      document.body.style.width = "0px";
      document.body.style.height = "0px";
      document.body.style.overflow = "hidden";
    },
    "closeWindow": function closeWindow(result) {
      window.parent.postMessage({
        mtype: 'close',
        data: result
      }, '*');
    },
    "getDevice": function getDevice() {
      //获取设备信息
      return {
        "getPlatform": function getPlatform(successBack, errorBack) {
          var platform = navigator.platform;
          successBack(platform);
        },
        "getUuid": function getUuid(success, error) {
          window.dd.device.base.getInterface({
            onSuccess: function onSuccess(data) {
              success(data);
            },
            onFail: function onFail(err) {
              error(err);
            }
          });
        },
        "getDpi": function getDpi() {
          errorMsg();
        }
      };
    },
    "getIM": function getIM() {
      return {
        "openChat": function openChat(address, success, error) {
          errorMsg();
        },
        "openSessionList": function openSessionList(success, error) {
          errorMsg();
        },
        "getUnreadCount": function getUnreadCount(successBack, error) {
          errorMsg();
        }
      };
    },
    "getPhone": function getPhone() {
      //拨打电话
      return {
        "call": function call(phoneNumber, successBack, errorBack) {
          try {
            window.dd.biz.telephone.showCallMenu({
              phoneNumber: phoneNumber,
              // 期望拨打的电话号码
              code: '+86',
              // 国家代号，中国是+86
              showDingCall: true,
              // 是否显示钉钉电话
              onSuccess: function onSuccess() {
                successBack();
              },
              onFail: function onFail(e) {
                errorBack(e);
              }
            });
          } catch (error) {
            try {
              window.location.href = "tel:" + phoneNumber;
              successBack();
            } catch (e) {
              errorBack(e);
            }
          }
        }
      };
    },
    "getSMS": function getSMS() {
      //发送短信
      return {
        "sendMsg": function sendMsg(phoneNumber, msg, success, error) {
          try {
            window.location.href = "sms:" + phoneNumber + '&body=' + encodeURI(msg);
            success();
          } catch (e) {
            error(e);
          }
        }
      };
    },
    "getAudio": function getAudio() {
      //录音
      return {
        "openRecorder": function openRecorder(successBack, errorBack) {
          errorBack('暂不支持该功能！');
        }
      };
    },
    "getLocation": function getLocation() {
      //获取当前位置
      return {
        "getCurrentPosition": function getCurrentPosition(successBack, errorBack) {
          try {
            window.dd.device.geolocation.get({
              targetAccuracy: 200,
              coordinate: 0,
              withReGeocode: false,
              useCache: true,
              //默认是true，如果需要频繁获取地理位置，请设置false
              onSuccess: function onSuccess(res) {
                var position = {
                  latitude: res.latitude,
                  longitude: res.longitude,
                  altitude: '',
                  accuracy: res.accuracy,
                  altitudeAccuracy: '',
                  heading: '',
                  speed: ""
                };
                successBack(position);
              },
              onFail: function onFail(err) {
                errorBack(err);
              }
            });
          } catch (er) {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function (position) {
                var p = position.coords;
                successBack(p);
              });
            } else {
              alert('您的浏览器不支持获取地理位置！');
            }
          }
        }
      };
    },
    "getVibrator": function getVibrator() {
      //设备震动
      return {
        "vibrate": function vibrate(milliseconds, successBack, errorBack) {
          window.dd.device.notification.vibrate({
            duration: milliseconds,
            //震动时间，android可配置 iOS忽略
            onSuccess: function onSuccess(result) {
              successBack();
            },
            onFail: function onFail(err) {
              errorBack();
            }
          });
        }
      };
    },
    "getEmail": function getEmail() {
      //发送邮件
      return {
        "sendEmail": function sendEmail(address, content, successBack, errorBack) {
          try {
            window.location.href = 'mailto:' + encodeURI(address) + '?body=' + encodeURI(content);
            successBack();
          } catch (e) {
            errorBack(e);
          }
        }
      };
    },
    "getNotification": function getNotification() {
      //提供通知
      return {
        "notice": function notice(id, title, content, clickUrl) {
          errorMsg();
        },
        "scheduleNotice": function scheduleNotice(id, title, content, firstTime, period, clickUrl) {
          errorMsg();
        },
        "cancelNotice": function cancelNotice(id) {
          errorMsg();
        }
      };
    },
    "getNews": function getNews() {
      //访问本地资讯
      return {
        "showColumnList": function showColumnList(siteId, columnId, columnName) {
          errorMsg();
        },
        "showNewsDetail": function showNewsDetail(siteId, siteName, articleId, articleTitle, url) {
          errorMsg();
        }
      };
    },
    "getCamera": function getCamera() {
      //拍照
      return {
        "takePicture": function takePicture(successBack, errorBack) {
          window.dd.biz.util.uploadImage({
            compression: true,
            //(是否压缩，默认为true压缩)
            multiple: false,
            //是否多选，默认false
            max: 1,
            //最多可选个数
            quality: 50,
            // 图片压缩质量, 
            resize: 50,
            // 图片缩放率
            onSuccess: function onSuccess(result) {
              var url = result[0];
              successBack({
                pic: url,
                fileName: ''
              });
            },
            onFail: function onFail(err) {
              errorBack(err);
            }
          });
        },
        "takePhoto": function takePhoto(successBack, errorBack) {
          window.dd.biz.util.uploadImage({
            compression: true,
            //(是否压缩，默认为true压缩)
            multiple: false,
            //是否多选，默认false
            max: 1,
            //最多可选个数
            quality: 50,
            // 图片压缩质量, 
            resize: 50,
            // 图片缩放率
            onSuccess: function onSuccess(result) {
              var url = result[0];
              successBack({
                pic: url,
                fileName: ''
              });
            },
            onFail: function onFail(err) {
              errorBack(err);
            }
          });
        }
      };
    },
    "getUser": function getUser() {
      //获取用户信息
      return {
        "showUserDetail": function showUserDetail(userId, userName) {
          errorMsg();
        }
      };
    },
    "getScan": function getScan() {
      //扫描二维码
      return {
        "scan2DBarCode": function scan2DBarCode(successBack, errorBack) {
          window.dd.biz.util.scan({
            type: "all",
            // type 为 all、qrCode、barCode，默认是all。
            tips: "",
            //进入扫码页面显示的自定义文案
            onSuccess: function onSuccess(data) {
              //onSuccess将在扫码成功之后回调

              /* data结构
                { 'text': String}
              */
              var code = {
                code: data.text
              };
              successBack(code);
            },
            onFail: function onFail(err) {
              errorBack(err);
            }
          });
        }
      };
    },
    "getLog": function getLog() {
      //保存日志
      return {
        "log": function log(content, successBack, errorBack) {
          try {
            var div = document.createElement('div');
            div.style.display = 'none';
            div.innerHTML = content;
            document.body.appendChild(div);
            successBack();
          } catch (e) {
            errorBack(e);
          }
        },
        "error": function error(content) {}
      };
    },
    "getSystem": function getSystem() {
      //提供与操作系统相关的能力
      return {
        "startActivity": function startActivity(intent, errorBack, successBack) {
          errorMsg();
        },
        "openSchema": function openSchema(schema, errorBack, successBack) {
          errorMsg();
        },
        "openFeedback": function openFeedback(errorBack, successBack) {
          errorMsg();
        }
      };
    },
    "getCryptor": function getCryptor() {
      //提供加密解密能力
      return {
        "RSA": function RSA(data, pubKey, success, error) {
          errorMsg();
        }
      };
    }
  };

  function errorMsg() {
    alert("暂不支持该功能！");
    return false;
  }

  return portal;
}();

export default DingTalk;